export { default } from './ChatActionsDropdown';
export { default as template } from './chat-actions-dropdown.tpl';
